import { usePlatforms } from '@mint-lib/routing-context';

import { Platform } from '../types/index.js';
import { transformPlatformsResponse } from '../utils/platforms.js';
import { useIntegrationLayoutRouteApi } from './useIntegrationsRouteApi.js';

export const useSelectedPlatform = (): Platform => {
  const { integration } = useIntegrationLayoutRouteApi().useParams();

  const { platformByLabel } = usePlatforms({ excludeDeleted: true });
  const fixedPlatformName: Record<string, string> = {
    google_analytics: 'ga4',
  };

  const platformName = fixedPlatformName[integration] ?? integration;
  const platform = platformByLabel?.[platformName];

  return transformPlatformsResponse(platform);
};
